"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M6.042 7.113c-.383.183-.72.449-.985.779v-.001l-2.309 2.86h5.12a2.67 2.67 0 0 1 2.635-2.254h1.282a.417.417 0 0 1 .417.417v.772h1.35a.418.418 0 0 1 0 .835h-1.35v1.294h1.35a.418.418 0 0 1 0 .835h-1.35v.77c0 .23-.187.417-.417.417h-1.282a2.67 2.67 0 0 1-2.634-2.252H1.912a1.044 1.044 0 0 0-1.078 1.043v1.685c0 .574.467 1.041 1.04 1.041h.386a.418.418 0 0 1 0 .835h-.386A1.876 1.876 0 0 1 0 14.313v-1.685c0-.964.73-1.76 1.666-1.864l2.743-3.397A3.67 3.67 0 0 1 7.267 6h6.611a3.683 3.683 0 0 1 2.72 1.205l3.22 3.544h1.464a2.721 2.721 0 0 1 .001 5.443h-.825a1.878 1.878 0 0 1-3.753-.071 1.876 1.876 0 0 1 3.594-.763h.984a1.887 1.887 0 1 0 0-3.774h-1.605l-.038.001h-3.19a.417.417 0 1 1 0-.834h2.242l-2.711-2.984a2.849 2.849 0 0 0-2.102-.932H7.266c-.424 0-.842.095-1.224.278Zm2.629 4.014a1.835 1.835 0 0 0 1.832 1.875h.865V9.331h-.865a1.836 1.836 0 0 0-1.832 1.796Zm9.174 4.256a1.043 1.043 0 1 0 1.475 1.476 1.043 1.043 0 0 0-1.476-1.476Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M3.709 14.938c-.27.335-.417.752-.417 1.182a1.88 1.88 0 0 0 1.844 1.911 1.877 1.877 0 0 0 1.91-1.844h8.451a.418.418 0 0 0 0-.835H6.883a1.877 1.877 0 0 0-3.174-.414Zm.418 1.183a1.043 1.043 0 1 1 2.086-.004 1.043 1.043 0 0 1-2.086.004Z",
    clipRule: "evenodd"
  })]
});